import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import useTranslation from 'next-translate/useTranslation';
import { ReactElement } from 'react';
import { BaseField, MultiCheckBoxField, SwitchField } from '@components/form';
import {
    accordionSummarySx,
    accordionSwitchSx,
    accordionRootSx,
} from '@utils/consts/switchAccordion';
import { FormProps } from '@utils/types/form';

interface FieldsProps extends FormProps {
    analysesOptions?: Record<string, string>;
}

const Fields = ({ analysesOptions, ...formProps }: FieldsProps): ReactElement => {
    const { t } = useTranslation('common');
    const { watch } = formProps;
    const linkAnalyses = watch('linkAnalyses') as boolean;
    const addNote = watch('addNote') as boolean;

    return (
        <>
            <SwitchField
                inputSx={accordionSwitchSx}
                label={t('print.decisionModal.sameCases.switchLabel')}
                name="displaySameCaseDecisions"
                {...formProps}
            />
            <Accordion expanded={linkAnalyses} sx={accordionRootSx} disableGutters>
                <AccordionSummary sx={accordionSummarySx}>
                    <SwitchField
                        inputSx={accordionSwitchSx}
                        label={t('print.decisionModal.linkedAnalysis.switchLabel')}
                        name="linkAnalyses"
                        {...formProps}
                    />
                </AccordionSummary>
                <AccordionDetails>
                    <MultiCheckBoxField
                        checkAllLabel={t('print.decisionModal.linkedAnalysis.checkAll')}
                        label={t('print.decisionModal.linkedAnalysis.label')}
                        name="linkedAnalyses"
                        options={analysesOptions || {}}
                        {...formProps}
                    />
                </AccordionDetails>
            </Accordion>
            <Accordion expanded={addNote} sx={accordionRootSx} disableGutters>
                <AccordionSummary sx={accordionSummarySx}>
                    <SwitchField
                        inputSx={accordionSwitchSx}
                        label={t('print.decisionModal.note.switchLabel')}
                        name="addNote"
                        {...formProps}
                    />
                </AccordionSummary>
                <AccordionDetails>
                    <BaseField
                        label={t('print.decisionModal.note.label')}
                        name="note"
                        placeholder={t('print.decisionModal.note.placeholder')}
                        rows={5}
                        type="textarea"
                        multiline
                        {...formProps}
                    />
                </AccordionDetails>
            </Accordion>
        </>
    );
};

export default Fields;
